var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenExpire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_line"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 33499"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 15 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3967 4.18132C12.2441 3.27289 10.5834 3.27289 9.43081 4.18132L3.84179 8.5863C3.35978 8.96619 3.0804 9.5334 3.0804 10.1321V17.3246C3.0804 18.4292 4.01314 19.3246 5.16374 19.3246H17.6637C18.8143 19.3246 19.7471 18.4292 19.7471 17.3246V10.1321C19.7471 9.5334 19.4677 8.96619 18.9857 8.5863L13.3967 4.18132ZM8.10886 2.63553C10.0299 1.12149 12.7976 1.12149 14.7186 2.63553L20.3076 7.04051C21.2716 7.8003 21.8304 8.93471 21.8304 10.1321V17.3246C21.8304 19.5338 19.9649 21.3246 17.6637 21.3246H5.16374C2.86255 21.3246 0.99707 19.5338 0.99707 17.3246V10.1321C0.99707 8.9347 1.55583 7.80029 2.51984 7.04051L8.10886 2.63553Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 55",
    d: "M22.9951 12.0012V10.0012H18.9951V12.0012H22.9951ZM18.9951 12.0012C18.9951 13.0296 19.0199 13.8504 19.0339 14.4859C19.0484 15.1474 19.0492 15.5565 19.0213 15.8792C18.9827 16.3255 18.9105 16.6059 18.3885 17.3101L21.6018 19.6923C22.4631 18.5304 22.8909 17.5608 23.0064 16.2237C23.0556 15.6546 23.047 15.0385 23.0329 14.3979C23.0182 13.7311 22.9951 12.9727 22.9951 12.0012H18.9951ZM18.3885 17.3101C18.2208 17.5362 17.8377 17.8323 16.4775 17.9596C15.086 18.0898 13.3995 18.0012 10.9951 18.0012V22.0012C13.0907 22.0012 15.2125 22.0955 16.8502 21.9422C18.5192 21.786 20.3861 21.3321 21.6018 19.6923L18.3885 17.3101Z",
    fill: "url(#paint0_linear_2816_72825)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 56",
    d: "M9.49512 20.325H13.4951",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 56_2",
    d: "M19.7302 12.0012C19.7302 12.5903 20.2078 13.0678 20.7969 13.0678C21.386 13.0678 21.8635 12.5903 21.8635 12.0012H19.7302ZM21.8635 12.0012V10.0012H19.7302V12.0012H21.8635Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1667 16.0004C18.0161 16.0004 17.0833 16.8958 17.0833 18.0004C17.0833 19.1049 18.0161 20.0004 19.1667 20.0004C20.3173 20.0004 21.25 19.1049 21.25 18.0004C21.25 16.8958 20.3173 16.0004 19.1667 16.0004ZM15 18.0004C15 15.7912 16.8655 14.0004 19.1667 14.0004C21.4679 14.0004 23.3333 15.7912 23.3333 18.0004C23.3333 20.2095 21.4679 22.0004 19.1667 22.0004C16.8655 22.0004 15 20.2095 15 18.0004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4062 6C12.0656 6 12.6002 6.51889 12.6002 7.15898V11.7949C12.6002 12.435 12.0656 12.9539 11.4062 12.9539C10.7467 12.9539 10.2121 12.435 10.2121 11.7949V7.15898C10.2121 6.51889 10.7467 6 11.4062 6ZM10.2002 15.266C10.2002 14.6259 10.7348 14.107 11.3942 14.107H11.4062C12.0656 14.107 12.6002 14.6259 12.6002 15.266C12.6002 15.9061 12.0656 16.425 11.4062 16.425H11.3942C10.7348 16.425 10.2002 15.9061 10.2002 15.266Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2816_72825",
    x1: 10.2415,
    y1: 11.5997,
    x2: 40.7441,
    y2: 20.1805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF974A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC5A5A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenExpire);
export default __webpack_public_path__ + "static/media/token_expire.188c590e453f5032cadff6f086ba7279.svg";
export { ForwardRef as ReactComponent };